import React from 'react'
import { ImageLabelLineProps } from './ImageLabelLine.types'
import styles from './ImageLabelLine.module.scss'
import cl from 'classnames'
import { ImagePortrait } from '../ImagePortrait'
import { Text1 } from '../Text1'

const ImageLabelLineComponent = (props: ImageLabelLineProps) => {
  const {
    className,
    style,
    imgSrc,
    label
  } = props

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
    >
      <ImagePortrait
        src={imgSrc}
        width={20}
      />
      <Text1 style={{ marginLeft: 10 }}>{label}</Text1>
    </div>
  )
}

const ImageLabelLine = ImageLabelLineComponent
export { ImageLabelLine }
